import en from './en.json';
import th from './th.json';
const langOptions = {
  en,
  th,
};

export default langOptions;
